// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-textura-js": () => import("./../../../src/pages/textura.js" /* webpackChunkName: "component---src-pages-textura-js" */),
  "component---src-templates-texture-js": () => import("./../../../src/templates/texture.js" /* webpackChunkName: "component---src-templates-texture-js" */)
}

